import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavItem } from 'interfaces/NavTypes';
import { Link } from '@mui/material';

import { getNavTitle } from 'utils/getNavTitle';
import { getRouteProps } from 'utils/getRouteProps';

type HeaderLinkProps = {
  item: NavItem;
};

export const HeaderLink: FC<HeaderLinkProps> = ({ item }) => {
  const { t } = useTranslation();
  const props = getRouteProps(item);

  return (
    <Link
      sx={{
        'p': 2,
        'fontWeight': 600,
        '&:hover': { textDecorationColor: (theme) => theme.palette.primary.main },
      }}
      {...props}
    >
      {getNavTitle(item, t)}
    </Link>
  );
};
